import { createSlice } from "@reduxjs/toolkit";

const initialState = () => ({
    userActive: false,
    userInfo: {},
    webSocketClientId:null
})


const authSlice = createSlice({
    name:'user_auth',
    initialState:initialState(),
    reducers: {
        resetAuth: state => initialState(),
        isLogin:(state)=> {
          state.userActive = true
        },
        isNotLogin:(state)=>{
            state.userActive = false
        },
        userInformation:(state, action)=>{            
            state.userInfo = action.payload
        },
        alterWebSocketClientId:(state, action)=>{            
            state.webSocketClientId = action.payload
        }
    }
})

export const {resetAuth, isLogin, isNotLogin, userInformation, alterWebSocketClientId} = authSlice.actions

export default authSlice.reducer